export enum VisibilityMode {
  Normal = 'normal',
  AutoHide = 'autoHide',
  Fixed = 'fixed',
}

export type VisibilityContextType = {
  visibilityMode: VisibilityMode | null;
  setVisibilityMode: React.Dispatch<React.SetStateAction<VisibilityMode | null>>;
};

export interface ArrayItemsNavBar {
  name: string;
  link: string;
}